import { Injectable } from '@angular/core';
import { ApiConstants } from '../shared/constants/api.constants';
import { ApiServices } from '../shared/services/api.services';

@Injectable()
export class ForgotPasswordService {

  private header: Object;

  constructor(private apiService: ApiServices, private apiConstants: ApiConstants) {
    this.header = {
      'Content-Type': 'application/json',
    };
  }

  sendResetPasswordLink(params: any) {
    return this.apiService.serviceCall(
      this.apiConstants.authUrl.sendResetLink.url,
      this.apiConstants.authUrl.sendResetLink.method,
      params,
      null,
      this.header
    );
  }

  resetPassword(params: any) {
    return this.apiService.serviceCall(
      this.apiConstants.authUrl.resetPassword.url,
      this.apiConstants.authUrl.resetPassword.method,
      params,
      null,
      this.header
    );
  }

  isLoggedIn() {
    const header = {};
    return this.apiService.serviceCall(
      this.apiConstants.authUrl.validate.url,
      this.apiConstants.authUrl.validate.method,
      null,
      null,
      header
    );
  }

  getMfaStatus(params: any, options: any, success: any, error: any): void {
    this.apiService.serviceCall(
      this.apiConstants.authUrl.mfaStatus.url,
      this.apiConstants.authUrl.mfaStatus.method,
      params,
      options,
      this.header
    ).subscribe((data) => success(data), err => error(err));
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/forgot.password/forgot.password.service.ts